export const pageAni = {
  hidden: {
    y: 100,
    opacity: 0,
  },
  show: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.5,
      easing: "ease",
      when: "beforeChildren",
    },
  },
  exit: {
    opacity: 0,
    transition: { delay: 0.08, duration: 0.2, easing: "ease" },
  },
};
